<template>
  <div id="app" @click="pageClick">
    <!--<img src="./assets/logo.png">-->
    <router-view/>
  </div>
</template>

<script>
  import phoneUUID from '@/assets/phoneUUID';
export default {
	name: "App",
	data() {
		return {
			msg: '',
   		websock: null,
		};
	},

	created () {},
	mounted () {
		this.init();
	},
	updated () {
		if (!this.$store.state.isScan) this.initWebSocket();
	},
	destroyed () {
		this.websocketclose();
	},

	methods: {
		init () {},

	  //初始化websocket
	  initWebSocket() {
      if (window.location.hostname == 'localhost') return;
	  	let uuid = window.localStorage.getItem('Phoneuuid');
	  	if (!uuid || uuid == 'null') return;
	    const wsuri = "ws://fu.hdpos.cn:8088/waiter/" + uuid + '_6';
	    this.websock = new WebSocket(wsuri);
	    this.websock.onmessage = this.websocketonmessage;
	    this.websock.onopen = this.websocketonopen;
	    this.websock.onerror = this.websocketonerror;
	    this.websock.onclose = this.websocketclose;
	    // console.log('初始化');
	  },
	  // 连接建立之后执行send方法发送数据
	  websocketonopen() {
//	    let actions = this.printInfo; // 传输的数据
	  	let uuid = window.localStorage.getItem('Phoneuuid');
	  	if (!uuid || uuid == 'null') return;
	    this.websocketsend(JSON.stringify({"toUserId": uuid + '_6'}));
	    // console.log('传输的数据');
	  },
	  //连接建立失败重连
	  websocketonerror() {
	    this.initWebSocket();
	    // console.log('连接建立失败重连');
	  },
	  //数据接收
	  websocketonmessage(e) {
	  	// console.log(e)
	  	if (e.data && e.data != "null") {
	  		let data = JSON.parse(e.data);
	  		if (data.online == 0) {
//	  			phoneUUID(0);
	  			window.localStorage.removeItem('timestemp');
	  			let logindata = JSON.parse(window.localStorage.getItem('logindata'));
	  			logindata.passwordCode = '';
          window.localStorage.setItem('logindata', JSON.stringify(logindata));
          this.$router.push({ path: '/' });
          this.$alert('已被踢出下线！', '下线通知', {
            confirmButtonText: '确定',
            callback: action => {}
          });
          return;
        }
	  	}
	  },
	  //数据发送
	  websocketsend(data) {
	    this.websock.send(data);
	    // console.log('数据发送');
	  },
	  //关闭
	  websocketclose(e) {
	    // console.log('断开连接', e);
	  },

		pageClick () {
//			console.log(this.$store.state.first);
		},
	}
}
</script>

<style>
	.el-message-box {
		width: 80% !important;
		max-width: 400px !important;
	}
	.el-button--primary, .el-button--primary:focus, .el-button--primary:hover {
		background-color: #f5711d;
		border-color: #f5711d;
	}
	.el-message{
		padding: 10px 10px 10px 15px !important;
		top: 40% !important;
		min-width: 100px !important;
		max-width: 90% !important;
		background: rgba(0, 0, 0, .7) !important;
		border-color: rgba(0, 0, 0, .7) !important;
		border-radius: 100px !important;
	}
	.el-message__content {
		font-size: 12px;
	}
	#app {
		/* 文字禁止选中 */
	  -webkit-touch-callout: none; /* iOS Safari */
		-webkit-user-select: none; /* Chrome/Safari/Opera */
		-khtml-user-select: none; /* Konqueror */
		-moz-user-select: none; /* Firefox */
		-ms-user-select: none; /* Internet Explorer/Edge */
		user-select: none; /* Non-prefixed version, currently not supported by any browser */
	}

	body{margin: 0;padding: 0;font-size: 16px;line-height: 1;font-family: "Microsoft YaHei";background: #f4f4f4;height: 100%;width: 100%;}
	h1,h2,h3,h4,h5,h6{margin: 0;font-weight: normal;font-size: 16px;}
	p,dl,dd{margin: 0;}
	ul,ol{margin: 0;padding: 0;list-style: none;}
	a{text-decoration: none;color: #2c3e50;cursor: pointer;}
	i,em{font-style: normal;}
	strong,b{font-weight: normal;}
	img{border: none;vertical-align: bottom;}
	table{border-spacing: 0;border-collapse: collapse;}
	th,td{padding: 0;text-align: left;vertical-align: top;}
	input{border: none;background: none;outline: none;}
	textarea{resize: none;}
	.clearFix{zoom: 1;} /*ie7以下兼容*/
	.clearFix:after{content: ""; display: block; clear: both; font-size: 0; line-height: 0;}
</style>



// WEBPACK FOOTER //
// src/App.vue